import Datefield from '@/components/layout/datefield/Datefield.vue'
import Timefield from '@/components/layout/timefield/Timefield.vue'
import UploadAvatar from '@/components/layout/uploadImagem/UploadAvatar.vue'
import { BToast, BSpinner } from 'bootstrap-vue'
import mensagens from '@/util/mensagens'
import mascaras from '@/util/mascaras'
import { mapState, mapActions } from 'vuex'
import constants from '@/util/constants'
import util from '@/util'
import TelefoneInput from '@/components/layout/telefone/TelefoneInput'

export default {
  name: 'informacoes',
  components: {
    Datefield,
    Timefield,
    UploadAvatar,
    TelefoneInput,
    'b-toast': BToast,
    'b-spinner': BSpinner
  },
  props: {
    fotoUsuario: {
      type: Object,
      required: false
    }
  },

  computed: {
    ...mapState('usuarios', ['formulario', 'dadosRetorno', 'flagsDeControle', 'listaUnidadesDisponiveis'])
  },

  data: () => {
    return {
      comboEstados: [],
      comboUnidadesDisponiveis: [],
      diasSemanaOptions: [
        { valor: 'sunday', label: 'Dom' },
        { valor: 'monday', label: 'Seg' },
        { valor: 'tuesday', label: 'Ter' },
        { valor: 'wednesday', label: 'Qua' },
        { valor: 'thursday', label: 'Qui' },
        { valor: 'friday', label: 'Sex' },
        { valor: 'saturday', label: 'Sáb' }
      ],
      statusOptions: [
        { text: 'Sim', value: 1 },
        { text: 'Não', value: 0 }
      ]
    }
  },

  async mounted () {
    this.obterEstados()
    this.obterUnidadesDisponiveis()
  },

  methods: {
    ...mapActions('usuarios', ['ActionDefinirDadosTipoCorrespondente', 'ActionDefinirListaUnidades']),

    async obterEstados () {
      try {
        const resposta = await this.axios.get('/usuarios/estados')
        this.comboEstados = resposta.data.retorno.dados
      } catch (e) {
        this.comboEstados = []
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
    },

    eventoDigitarBuscaPorUnidade (valorDigitadoParaBusca, callbackFlagCarregamento) {
      clearTimeout(this.timeOutDigitacaoNocombo)
      let referenciaObjetoDaView = this

      this.timeOutDigitacaoNocombo = setTimeout(function () {
        referenciaObjetoDaView.obterUnidadesDisponiveis(valorDigitadoParaBusca, callbackFlagCarregamento)
      }, constants.tempoParaAguardarDigitacaoNoCombo)
    },

    async obterUnidadesDisponiveis (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }

      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'f_name': valorDigitadoParaBusca }
      }
      await this.ActionDefinirListaUnidades(parametrosRequisicao)
      this.comboUnidadesDisponiveis = this.listaUnidadesDisponiveis.map(function (registro) {
        return { label: registro.f_name, code: registro.f_id }
      })
      callbackFlagCarregamento = false
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    obterStatus (retorno) {
      switch (retorno) {
        case constants.statusUsuario.ativo:
        case constants.statusUsuario.loginNaoRealizado:
          return true
        default:
          return false
      }
    },

    mascaraTelefoneCelular (valor) {
      return mascaras.mascaraTelefoneCelular(valor)
    },

    receberDadosUploadAvatar (dadosArquivo) {
      this.formulario.f_photo = []
      this.formulario.f_photo = dadosArquivo
    }
  }
}
